import { render } from "./PopupSuccess.vue?vue&type=template&id=08e28013"
import script from "./PopupSuccess.vue?vue&type=script&lang=js"
export * from "./PopupSuccess.vue?vue&type=script&lang=js"

import "./PopupSuccess.vue?vue&type=style&index=0&id=08e28013&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__